import { render, staticRenderFns } from "./FooterNew.vue?vue&type=template&id=609abd7b&scoped=true&"
import script from "./FooterNew.vue?vue&type=script&lang=js&"
export * from "./FooterNew.vue?vue&type=script&lang=js&"
import style0 from "./FooterNew.vue?vue&type=style&index=0&id=609abd7b&lang=scss&scoped=true&"
import style1 from "./FooterNew.vue?vue&type=style&index=1&id=609abd7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609abd7b",
  null
  
)

export default component.exports